export default "__VITE_ASSET__CKDGaXz1__"